import { render } from "./coaching.vue?vue&type=template&id=530f40c2"
import script from "./coaching.vue?vue&type=script&lang=js"
export * from "./coaching.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__